<template>
    <div class="ticket-list-container">
      <h1 class="page-title">Ticket Details</h1>
      <div class="ticket-details-container">
        <h3>Ticket ID: {{ $route.params.ticketID }}</h3>
        <div v-if="loading">
          Loading...
        </div>
        <div v-else-if="error">
          {{ error }}
        </div>
        <div v-else>
          <!-- Type Field -->
          <p>
            <strong>Type:</strong>
            <span v-if="!isEditing">{{ ticket.type }}</span>
            <select v-else v-model="ticket.type">
              <option value="Feature">Feature</option>
              <option value="Bug">Bug</option>
              <option value="Design">Design</option>
            </select>
          </p>
          <!-- Status Field -->
          <p>
            <strong>Status:</strong>
            <span v-if="!isEditing">{{ ticket.status }}</span>
            <select v-else v-model="ticket.status">
              <option value="Open">Open</option>
              <option value="Live">Live</option>
              <option value="Developing">Developing</option>
              <option value="Stuck">Stuck</option>
            </select>
          </p>
          <!-- Added By and Timestamp (read-only) -->
          <p>
            <strong>Added by:</strong> {{ ticket.addedBy }}
          </p>
          <p>
            <strong>Timestamp:</strong> {{ formattedTimestamp }}
          </p>
          <!-- Summary Field -->
          <p>
            <strong>Summary:</strong>
            <span v-if="!isEditing">{{ ticket.summary }}</span>
            <input v-else type="text" v-model="ticket.summary" />
          </p>
          <!-- Description Field -->
          <p>
            <strong>Description:</strong>
            <span v-if="!isEditing">{{ ticket.description }}</span>
            <textarea v-else v-model="ticket.description"></textarea>
          </p>
          <!-- Action Buttons only for Admins -->
          <div v-if="isAdmin">
            <button class="action-button" v-if="!isEditing" @click="startEditing">
              Edit Ticket
            </button>
            <div v-else>
              <button class="action-button" @click="saveTicket">
                Save
              </button>
              <button class="action-outline-button" @click="cancelEdit">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { db } from "../firebaseConfig";
  import { doc, getDoc, updateDoc } from "firebase/firestore";
  
  export default {
    name: "BugReportEdit",
    data() {
      return {
        ticket: null,
        loading: false,
        error: null,
        isEditing: false,
        backupTicket: null,
        // Replace this with your actual admin check logic (e.g., from a Vuex store)
        isAdmin: true
      };
    },
    computed: {
      // Convert Firestore timestamp to a more readable string
      formattedTimestamp() {
        if (this.ticket && this.ticket.timestamp && this.ticket.timestamp.toDate) {
          return this.ticket.timestamp.toDate().toLocaleString();
        }
        return "";
      }
    },
    created() {
      this.fetchTicket();
    },
    methods: {
      async fetchTicket() {
        this.loading = true;
        const ticketID = this.$route.params.ticketID;
        try {
          const ticketRef = doc(db, "devTickets", ticketID);
          const ticketSnap = await getDoc(ticketRef);
          if (ticketSnap.exists()) {
            this.ticket = ticketSnap.data();
          } else {
            this.error = "Ticket not found";
          }
        } catch (err) {
          console.error("Error fetching ticket:", err);
          this.error = "Error fetching ticket";
        } finally {
          this.loading = false;
        }
      },
      startEditing() {
        // Save a copy for potential cancellation
        this.backupTicket = JSON.parse(JSON.stringify(this.ticket));
        this.isEditing = true;
      },
      cancelEdit() {
        // Revert ticket changes from the backup
        this.ticket = this.backupTicket;
        this.isEditing = false;
      },
      async saveTicket() {
        try {
          const ticketID = this.$route.params.ticketID;
          const ticketRef = doc(db, "devTickets", ticketID);
          // Update ticket with the current edited values
          await updateDoc(ticketRef, {
            type: this.ticket.type,
            status: this.ticket.status,
            summary: this.ticket.summary,
            description: this.ticket.description
          });
          alert("Ticket updated successfully!");
          this.isEditing = false;
          // Optionally, re-fetch the ticket details from Firestore
          await this.fetchTicket();
        } catch (err) {
          console.error("Error updating ticket:", err);
          alert("Error updating ticket");
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .ticket-details {
    padding: 20px;
  }
  
  .ticket-list-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
    font-family: "Poppins", sans-serif;
    color: #111827;
  }
  
  .ticket-details-container {
    max-width: 500px;
    padding: 50px;
    margin: 0 auto;
    border-radius: 30px;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #c9bf9b54;
  }
  
  .ticket-details-container input {
    font-family: "Courier Prime", monospace;
    width: 70%;
    padding: 12px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 2px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
  }
  
  .ticket-details-container select {
    font-family: "Courier Prime", monospace;
    width: 75%;
    padding: 10px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 2px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
  }
  
  .ticket-details-container textarea {
    font-family: "Courier Prime", monospace;
    width: 92%;
    max-width: 255px;
    min-height: 150px;
    padding: 10px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 2px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
  }
  </style>
  
  <style src="./elements.css" scoped></style>
  